import { render, staticRenderFns } from "./MbPresentation.vue?vue&type=template&id=0d6e38d1&"
import script from "./MbPresentation.vue?vue&type=script&lang=js&"
export * from "./MbPresentation.vue?vue&type=script&lang=js&"
import style0 from "./MbPresentation.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports